<template>
  <div class="Chart">
    <div 
      v-for="(series, seriesIndex) in data"
      v-bind:key="seriesIndex">
      <div
        :class="`Chart-x Chart-x${seriesIndex}`"
        v-for="(value, key, index) in series.data"
        :key="key"
        :style="
          `width: ${getXItemWidth(Object.keys(series.data).length)}%;
          left: ${getXItemWidth(Object.keys(series.data).length)*index}%;
          opacity: ${(seriesIndex % 2 === 0 ? '0.5' : '1')};`
        ">
        <div class="Chart-yValue" 
          :style="
            `bottom: calc(${bottomHeight(value)}% + 5px);`">{{ value }}</div>
        <div class="Chart-dot" 
          :style="
            `bottom: ${bottomHeight(value)}%;`
          "></div>
        <div
          class="Chart-xAxis"
          v-if="seriesIndex === 0 && index % 2 === 0">
          {{ key.substring(key.length - 2) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import './_Chart.scss';

export default {
  props: {
    data: {
      type: Array,
    },
  },
  methods: {
    getXItemWidth: function (totalItems) {
      return 100 / totalItems;
    },
    bottomHeight: function (value) {
      const highestValue = this.highestValue;

      if (highestValue === 0) {
        return 0;
      }

      return value / this.highestValue * 100;
    },
  },
  computed: {
    highestValue: function () {
      let currentHighest = 0;

      // foreach series
      for (let i = 0; i < this.data.length; i++) {
        for (let j = 0; j < Object.keys(this.data[i].data).length; j++) {
          let dataValue = this.data[i].data[Object.keys(this.data[i].data)[j]];          
          if (dataValue > currentHighest) {
            currentHighest = dataValue;
          }
        }
      }
      return currentHighest * 1.2;
    },
  }
}
</script>
